<template>
  <div class="axj_web_top">
    <div class="web_top_logo">
      <img :src="webTopFiles.web_top_logo_url"/>
    </div>
    <div class="web_top_menu" ref="menu">
      <div class="web_top_menu_item" ref="page">
        <div class="web_top_menu_item_title" @click="handleMenuItemActive('page')">
          <label>首页</label>
        </div>
        <div class="web_top_menu_item_icon">
        </div>
      </div>
      <div class="web_top_menu_item" ref="login">
        <div class="web_top_menu_item_title" @click="handleMenuItemActive('login')">
          <label>机构入口</label>
        </div>
        <div class="web_top_menu_item_icon">
        </div>
      </div>
      <div class="web_top_menu_item" ref="about">
        <div class="web_top_menu_item_title" @click="handleMenuItemActive('about')">
          <label>关于我们</label>
        </div>
        <div class="web_top_menu_item_icon">
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  mounted() {
    // let that=this
    // window.onresize=()=>{
    //   return (()=>{
    //     this.fitWindow()
    //   })()
    // }
    // this.initMenuItemActive()
    // this.fitWindow()
    this.initMenuItemActive()
  },
  methods:{
    initMenuItemActive(){
      this.$refs['page'].lastChild.style.visibility="visible"
      this.$refs['page'].firstChild.firstChild.style.color="#ffffff"
    },
    handleMenuItemActive(v){
      for(let x=0; x< this.$refs.menu.children.length;x++){
        this.$refs.menu.children[x].firstChild.firstChild.style.color="#534D63"
        this.$refs.menu.children[x].lastChild.style.visibility="hidden"
      }
      this.$refs[v].lastChild.style.visibility="visible"
      this.$refs[v].firstChild.firstChild.style.color="#ffffff"
      this.$emit("menu-item-change",v)
    }
  },
  name: "axj_web_top",
  data(){
    return{
      thisPageConfig:{
        //爱学界默认顶部高度
        defaultAxjWebTopHeight:100,
        //爱学界默认图标高度
        defaultAxjWebTopImageHeight:52.8,
        //爱学界默认图标宽度
        defaultAxjWebTopImageWith:169.1,
        //爱学界图标默认上边距
        defaultAxjWebTopImageMarginTop:23,
        //爱学界图标默认左边距
        defaultAxjWebTopImageMarginLeft:100,
        //爱学界菜单栏默认右边距
        defaultAxjWebTopMenuMarginRight:100,
        //爱学界菜单栏默认上边距
        defaultAxjWebTopMenuMarginTop:39,
        //爱学界菜单栏元素默认右边距
        defaultAxjWebTopMenuItemMarginRight:109,
        defaultAxjWebTopMenuItemTitleFontSize:17
      },
      webTopFiles:{
        web_top_logo_url:"https://img.aixuejie.cn/extra/showclub/5_1605171275/5_爱学界_1605171282_38a21fc5df7cebaa4362f0d6058e1032.png",
        windowWidth: document.documentElement.clientWidth,  //实时屏幕宽度
        windowHeight: document.documentElement.clientHeight,   //实时屏幕高度
      }
    }
  }
}
</script>

<style scoped lang="scss">
.axj_web_top{
  //background-color: #3a8ee6;
  //height: 100px;
  height: 72.588px;
  display: flex;
  //background-color: #13ce66;
  .web_top_logo{
    height: 100%;
    img{
      margin-top: 17.23px;
      margin-left: 75px;
      height: 38.43px;
    }
  }
  .web_top_menu{
    margin-left: auto;
    display: flex;
    margin-top: 28.49px;
    margin-right: 75px;
    .web_top_menu_item:not(:last-child){
      margin-right: 81.75px;
    }
    .web_top_menu_item{

      display: flex;
      flex-flow: column;
      align-items: center;
      .web_top_menu_item_title{
        label{
          font-family: Source Code Pro;
          font-style: normal;
          font-weight: normal;
          font-size: 12.58px;
          line-height: 21px;
          color: #534D63;
        }
        label:hover{
          color: #ffffff;
          cursor: pointer;
        }
      }
      .web_top_menu_item_icon{
          visibility: hidden;
          margin-top: 7.3px;
          width: 13.5px;
          border-bottom: 2px white solid;
          border-radius: 16px;
          display: flex;
      }
    }
  }
}
//1400*789

//<1309*717
//@media screen and(max-width: 1310px) and(max-height: 718px) {
//  .axj_web_top{
//    .web_top_logo{
//      img{
//        margin-top: 15.26px;
//        margin-left: 68.17px;
//        height: 36.51px;
//      }
//    }
//    .web_top_menu{
//      .web_top_menu_item{
//        .web_top_menu_item_title{
//          label{
//            font-size: 9px;
//          }
//        }
//      }
//    }
//  }
//}
</style>



// WEBPACK FOOTER //
// src/views/axj_web/component/web_top/index.vue